import styled from 'styled-components'

import { Td, Th, Tr } from '@10xLabs/react-web/components/Table'

export const MainTh = styled(Th)<TSFixMe>`
  :first-child {
    padding-left: 40px;
  }

  :last-child {
    padding-right: 40px;
  }
`

export const MainTr = styled(Tr)<{ isDetailsOpen?: boolean }>`
  box-shadow: ${(props): string =>
    props.isDetailsOpen ? '0 4px 7px 0 rgba(0, 0, 0, 0.21)' : '0 1px 1px 0 rgba(0, 0, 0, 0.16)'};
  background-color: transparent;
  cursor: pointer;

  &:nth-child(even) {
    background-color: transparent;
  }
`

export const MainTd = styled(Td)<TSFixMe>`
  :first-child {
    padding-left: 40px;
  }

  :last-child {
    padding-right: 40px;
  }
`

export const DetailsTr = styled(Tr)<TSFixMe>`
  background-color: rgba(236, 236, 236, 0.3);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.16);

  &:nth-child(even) {
    background-color: rgba(236, 236, 236, 0.3);
  }
`

export const DetailsTd = styled(Td)<TSFixMe>`
  padding-bottom: 0;

  :first-child {
    padding-left: 40px;
  }

  :last-child {
    padding-right: 40px;
  }
`

export const Wrapper = styled.div<TSFixMe>`
  margin: -20px -30px -30px;
`
